import React, {useReducer, useContext} from 'react'
import { Action, KeyValuePayload } from '../../model'
import UserContext from 'src/provider/state-manager/userProvider'
import { stringify } from 'querystring';
import { getMember } from '@src/utils/helpers';



const AppInfoContext = React.createContext<any>(null)
const initialState = {
  token: "",
  userData: {},
  selectedValue: {},
  allMembers: null,
  basicAppInfo: {},
  selectedMember: null,
  result: {},
  editUser:{},
  submitUser: false,
  submitEditUser: false
};

const AppInfoReducer = (state: any, action: Action<KeyValuePayload>) => {
    switch(action.type){
        case "set-property": 
            return { ...state, [action.payload.key]: action.payload.value }
        case "set-value": 
            return {...state, [action.payload.key]:action.payload.value}
        case 'clear-data': 
            return { ...initialState }
    }
}

export const AppInfoProvider = (props: any) => {
    const {recoverUserData, clearuserData} = useContext(UserContext)
    const [state, dispatch] = useReducer(AppInfoReducer, {
      ...initialState
    })

    async function setInfoProperty (key: string, value: any) {
        let isString = typeof(value) === 'string' ? true : false
        let isNumber = typeof(value) === 'number' ? true : false
        localStorage.setItem(key, isString ? value : isNumber ? String(value) : JSON.stringify(value))
        await dispatch({type: "set-property", payload: {key, value}})
    }

    async function recoverAppData () {
        for (let item of Object.keys(initialState)) {
            let retrievedData = await localStorage.getItem(item)!
            retrievedData = ['number', 'string'].includes(typeof state[item]) ? retrievedData : ( !['null', 'undefined'].includes(retrievedData) ? JSON.parse(retrievedData): state[item])
            await setInfoProperty(item, retrievedData)
        }
    }

    async function clearAppData () {
        await dispatch({type: "clear-data", payload: {key: '', value: ''}})
    }

    async function recoverStatesData () {
        await Promise.all([
            recoverAppData(), recoverUserData() // other context state recovering method will be imported and added here
        ])
    }

    async function logout () {
        await Promise.all([
            localStorage.clear(), clearAppData(), clearuserData() // other context state clearing method will be import and added here
        ])
    }
  async function value (key:string, value:any) {
  localStorage.setItem(key, '')
   await dispatch({type:"set-value", payload:{key, value}})
  }
async function setFetchMembers (key:string, value:any) {
    await dispatch({type:'set-property', payload:{key, value}})
}
async function setSelectedMember(value:any) {
await dispatch({type:'set-property', payload:{key:"selectedMember", value}})
}
async function setEditUser(value:any) {
    await dispatch({type:'set-property', payload:{key:"editUser", value}})
    
}
async function setSubmitUser(value:any) {
    await dispatch({type:'set-property',payload:{key:"submitUser", value}})
}
async function setSubmitEditUser(value:any) {
    await dispatch({type:'set-property',payload:{key:"submitEditUser", value}})
}
    const stateActions = {
       setInfoProperty,
       recoverStatesData,
       clearAppData,
       logout,
       value,
       setFetchMembers,
       setSelectedMember,
       setEditUser,
       setSubmitUser,
       setSubmitEditUser
       
    }
    

    return (
        <AppInfoContext.Provider value={{info: state, ...stateActions}} >
            {props.children}
        </AppInfoContext.Provider>
    )
}

export default AppInfoContext